import React from 'react';
import EnvironmentList from "../../../components/Admin/Environment/EnvironmentList";

const AdminEnvironment = () => {
    return (
        <div>
            <main className="sl-main sl-mt-8">
                <div className={"sl-container sl-m-auto sl-my-8"}>
                    <h1 className={`sl-mb-10 sl-text-xl sl-text-gray-900`}>Feature Flag Management</h1>
                    <EnvironmentList/>
                </div>
            </main>
        </div>
    );
};

export default AdminEnvironment;
